import { delayedCall, killDelayedCall ,ingenuity} from "@quest/base-core";
import { ReelPanel } from "@quest/murka-games-behavior-leopard";
import { SlotConstants } from "@quest/slot-core";
import { ReelGame } from "./Reel";

export class ReelPanelGame extends ReelPanel {
    protected reels: ReelGame[];

    /**
     * Overrided to kill delayes to stop anticipation issue while trbo + autoplay on.
     * @param id 
     * @param allReelSpining 
     * @returns 
     */
  protected stopReel(id: number, allReelSpining: boolean): void {
    if (!allReelSpining) {
      return;
    }
    if (this.reels[id].getIsSpining() && !this.paused) {
      let reelId = id;
      if (ingenuity.configData.stopReelViaPos) {
        this.reels[reelId].setStops(this.model.reelStops[reelId]);
      } else {
        this.reels[reelId].setStops(this.model.reelGrid[reelId]);
      }
      reelId++;
      if (reelId < this.reels.length) {
        let delay = Array.isArray(this.model.stopDelay) ? this.model.stopDelay[reelId] : this.model.stopDelay;
          if (this.model.anticipationSpin[reelId]) {
          delay = this.model.getAnticipationDelay(reelId);
          delayedCall(
            SlotConstants.AnticipationDelayTimer + reelId,
            this.model.getAnticipationRunAfterDelay(reelId),
            () => {
              killDelayedCall(SlotConstants.AnticipationDelayTimer + reelId);
              this.setAnticipation(reelId);
            },
            this
          );
        } 
        if (this.model.reelsJson[reelId].noDelay) {
          this.stopReel.bind(this, reelId, this.isSpining);
        } else if (ingenuity.configData.stopNowWithDelay && this.stopNow) {
          if (this.model.anticipationSpin[reelId]) {
            delayedCall(
              SlotConstants.StopReelId + reelId,
              delay,
              () => {
                killDelayedCall(SlotConstants.StopReelId + reelId);
                this.stopReel(reelId, this.isSpining);
              },
              this
            );
          } else {
            delayedCall(
              SlotConstants.StopReelId + reelId,
              ingenuity.configData.stopNowWithDelay,
              () => {
                killDelayedCall(SlotConstants.StopReelId + reelId);
                this.stopReel( reelId, this.isSpining);
              },
              this
            );
          }
        } else {
          delayedCall(
            SlotConstants.StopReelId + reelId,
            delay,
            () => {
              killDelayedCall(SlotConstants.StopReelId + reelId);
              this.stopReel(reelId, this.isSpining);
            },
            this
          );
        }
      }
    }
  }  

  /**
   *  Overrided to kill delayes to stop anticipation issue while trbo + autoplay on.
   * @param stops 
   * @returns 
   */
  public stop(stops: any): void {
       killDelayedCall(SlotConstants.StopSpinTimer);
       if (!this.isSpining) {
           delayedCall(SlotConstants.StopSpinTimer, 100, this.stop.bind(this, stops), this, stops);
           return;
       }
       let i = 0;
       if (Array.isArray(stops)) {
           this.model.reelStops = stops;
       }
       else if (typeof stops === "object" && stops && stops.data) {
           if (Array.isArray(stops.data)) {
               this.model.reelStops = stops.data;
           }
           else {
               throw new Error("No response recived or response not in the form of an Array" + stops.data);
           }
       }
       else {
           throw new Error("No response recived or response not in the form of an Array" + stops);
       }
       if (this.model.noStopDelay) {
           for (i = 0; i < this.reels.length; i++) {
               this.reels[i].setStops(stops[i]);
           }
       }
       else if (this.model.reelsJson[i].noDelay) {
           this.stopReel.bind(this, i, true);
       }
       else {
           let delay = Array.isArray(this.model.stopDelay) ? this.model.stopDelay[i] : this.model.stopDelay;
           delay = this.stopNow ? ingenuity.configData.stopNowWithDelay : delay;
           delayedCall(SlotConstants.StopReelId + i, delay,()=>{
               killDelayedCall(SlotConstants.StopReelId + i)
               this.stopReel(i, true)
           },this);
       }
   }
}
